"use strict";
/* globals module */
/**
 * @module mediaGalleryFilesStreamsClient
 * @description  Media Gallery Files Streams Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Files Streams Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../httpApi");
var _1 = require("./");
var MediaGalleryFileStreamClient = /** @class */ (function () {
    function MediaGalleryFileStreamClient(mediaGalleryFilesStreamsRoute, apiClient) {
        this.mediaGalleryFilesStreamsRoute = mediaGalleryFilesStreamsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(MediaGalleryFileStreamClient.prototype, "routeDefinition", {
        get: function () {
            return this.mediaGalleryFilesStreamsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the file stream if successfully completed. If derived resource's format is passed, such as `width` and `height` for the image type of file resource, the operation will return a stream of the derived resource. Otherwise, stream of the original file resource will be retrieved.
     * @method
     * @param id Media Gallery Entry id which uniquely identifies media gallery file that needs to be retrieved.
     * @param data Media Gallery File object used to identify stream that needs to be retrieved from the system.
     * @returns A promise that is resolved once the get action has been performed.
     * @example // Request the original file stream
                    mediaGalleryFilesStreamsClient.get({id: '<file-id>'}, {mediaGalleryid: '<media-gallery-id>', t: '<timestamp>'})
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    MediaGalleryFileStreamClient.prototype.get = function (id, data) {
        return this.apiClient.get(this.mediaGalleryFilesStreamsRoute.get(id, data));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the file stream as a blob. If derived resource's format is passed, such as `width` and `height` for the image type of file resource, the operation will return a blob of the derived file resource. Otherwise, blob of the original file resource will be retrieved. For more information on Blob objects please see [Blob Documentation](https://developer.mozilla.org/en-US/docs/Web/API/Blob).
     * @method
     * @param id Media Gallery Entry id which uniquely identifies media gallery file that needs to be retrieved.
     * @param data Media Gallery File object used to identify stream that needs to be retrieved from the system.
     * @returns A promise that is resolved once the get action has been performed.
     * @example // Request the original blob
                    mediaGalleryFilesStreamsClient.getBlob('<file-id>', {mediaGalleryId:'<media-gallery-id>', t: '<timestamp>'})
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    MediaGalleryFileStreamClient.prototype.getBlob = function (id, data) {
        return this.apiClient.get(this.mediaGalleryFilesStreamsRoute.get(id, data), { 'Accept': 'application/octet-stream' });
    };
    /**
     * Returns a promise that is resolved once the update file stream action has been performed; this action will replace the existing stream with a new one. Alternatively, if a derived stream is being updated it will either create a new derived stream or replace the existing one. In order to update a derived stream, format needs to be passed (For example: `width` and `height` for the image type of file stream data type).
     * @method
     * @param data Media GalleryFile object used to identify stream that needs to be updated.
     * @param stream
     * @returns A promise that is resolved once the update file stream action has been performed.
     * @example // Update original file stream
                    mediaGalleryFilesStreamsClient.update({id:'<file-id>'}, <file-stream>)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    MediaGalleryFileStreamClient.prototype.update = function (data, stream) {
        var formData = new FormData();
        formData.append('file', stream);
        return this.apiClient.put(this.mediaGalleryFilesStreamsRoute.update(data), formData, { 'Content-Type': undefined });
    };
    /**
     * Returns a promise that is resolved once the create file stream action has been performed; this action will upload the specified blob. For more information on Blob objects please see [Blob Documentation](https://developer.mozilla.org/en-US/docs/Web/API/Blob).
     * @method
     * @param data Media GalleryFile object that need to be inserted into the system.
     * @param stream
     * @returns A promise that is resolved once the create file stream action has been performed.
     * @example mediaGalleryFilesStreamsClient.create({mediaGalleryId:'<media-gallery-id>'}, <blob>)
                   .then(function (data) {
                        // perform success action here
                   },
                    function (response, status, headers, config) {
                       // perform error handling here
                   });
    **/
    MediaGalleryFileStreamClient.prototype.create = function (data, stream) {
        var formData = new FormData();
        formData.append('file', stream);
        return this.apiClient.post(this.mediaGalleryFilesStreamsRoute.create(data), formData, { 'Content-Type': undefined });
    };
    var _a, _b;
    MediaGalleryFileStreamClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.MediaGalleryFileStreamRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.MediaGalleryFileStreamRoute !== "undefined" && _1.MediaGalleryFileStreamRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], MediaGalleryFileStreamClient);
    return MediaGalleryFileStreamClient;
}());
exports.MediaGalleryFileStreamClient = MediaGalleryFileStreamClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/ 
